export const sizes = {
  '16': "20",
  '20': "25",
  '24': "30",
  '27': "35",
  '32': "41",
};

export const headerAmount = ['single', 'double', 'triple']

export const headerSizes = {
  5.5:'2x6',
  7.25:'2x8',
  9.25: '2x10',
  11.25: '2x12'
}

export const ringRafterLayers = {
  '2 x 12': 11,
  '2 x 10' : 10,
  'LVL 1 1/2" x 11 3/4"': 12,
  'LVL 1 3/4" x 11 7/8"': 12,
  'LVL 1 3/4" x 14"': 14
}